export default {
  title: '',
  groups: [],
};
